import { Dimensions } from 'editor/src/store/design/types';

// eslint-disable-next-line max-len
const imagePlaceholder =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAUklEQVR4Ae3PMQ0AIBAAMcAF0/t3iY0LaR10z8xdHzjrEyI1IjUiNSI1IjUiNSI1IjUiNSI1IjUiNSI1IjUiNSI1IjUiNSI1IjUiNSI1IjUiNQ/q6wDahIYSaAAAAABJRU5ErkJggg==';
export const DIMENSIONS: Dimensions = { width: 50, height: 50 };

export default imagePlaceholder;
